exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".center{text-align:center}.right{text-align:right}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./src/styles/index.css
// module id = 675
// module chunks = 0